var FONT_WEIGHT = {
    NORMAL: 400,
    BOLD: 700,
};
export default FONT_WEIGHT;
//# sourceMappingURL=font-weight.js.map